import TomSelect from "tom-select";
window.TomSelect = TomSelect;